<template lang="html">
  <div>
    <blockers-item
      v-model="selectedItemId"
      :clone-id="cloneId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      >
        <template
          slot="locations"
          slot-scope="props"
        >
          <v-chip-group column>
            <v-chip
              v-for="(location, i) of props.item.locations"
              :key="i"
            >
              {{ location.locationName }}
            </v-chip>
          </v-chip-group>
        </template>
        <template
          slot="startTime"
          slot-scope="props"
        >
          <div>{{ displayTime(props.item.startTime) }} to {{ displayTime(props.item.endTime) }}</div>
        </template>
        <template
          slot="sunday"
          slot-scope="props"
        >
          <v-chip-group column>
            <template v-if="!hasAllDays(props.item)">
              <div>
                <template
                  v-for="(day, i) of daysLower"
                >
                  <v-chip
                    v-if="props.item[day]"
                    :key="i"
                  >
                    {{ daysShort[i] }}
                  </v-chip>
                </template>
              </div>
            </template>
            <v-chip
              v-else
              key="all"
            >
              All
            </v-chip>
          </v-chip-group>
        </template>
        <template
          slot="blockerType"
          slot-scope="props"
        >
          <div>{{ blockerTypeMap[props.item.blockerType].textShort }}</div>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {values, helpers, itemSelect} from '@/ft-vue-core'
import BlockersItem from './BlockersItem'

const {daysShort, daysLower} = values
const {displayTime} = helpers

export default {
  name: 'BlockersList',
  components: {
    BlockersItem
  },
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Blocker',
      types: 'Blockers',
      headers: [
        this.headerText('Name', 'name', true),
        this.headerSlot('Location', 'locations', true),
        this.headerText('Start', 'startDate', true),
        this.headerText('End', 'endDate', true),
        this.headerSlot('Time', 'startTime', true),
        this.headerSlot('Days', 'sunday', true),
        this.headerSlot('Type', 'blockerType', true),
        this.headerInvertedSwitch('Active', 'disabled', true)
      ],
      apiRecordCommand: 'diningBlocker',
      blockerTypes: []
    }
  },
  computed: {
    daysShort () {
      return daysShort
    },
    daysLower () {
      return daysLower
    },
    blockerTypeMap () {
      return this.blockerTypes.reduce((acc, b) => {
        acc[b.value] = b
        return acc
      }, {})
    }
  },
  methods: {
    displayTime,
    hasAllDays (item) {
      for (let day of daysLower) {
        if (!item[day]) return false
      }
      return true
    },
    listCommandFilter (command) {
      this.addCommandParamArrayVal(command, 'include_fields', 'locationNames', 'diningBlockerToLocation.locationName')
      return this.addCommandParam(command, 'children', true)
    },
    listResourceCommands () {
      return [
        {
          command: 'apiFieldOption',
          load: this.blockerTypes,
          loading: this.isLoading,
          params: {filter_methods: {forField: ['diningBlocker', 'blockerType']}}
        }
      ]
    }
  }
}
</script>
